export const NOTE_VALIDATION_RULES = {
    memberEmailAddress: {
        regex: {
            value: {
                pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                customMessageKey: "validation.customMessages.emailAddressRegex",
            },
        },
    },
    description: {
        isRequiredTrim: {
            value: true,
        },
    },
    subType: {
        isRequiredTrim: {
            value: true,
        },
    },
    followUpCategoryId: {
        isRequiredTrim: {
            value: true,
        },
    },
    transactionAmount: {
        minValue: {
            value: 0,
        },
    },
    recipientUserId: {
        isRequiredTrim: {
            value: true,
        },
    },
    clientId: {
        isRequiredTrim: {
            value: true,
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/noteValidationRules.js